<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Input from 'dashboard/components-next/input/Input.vue';
import Select from 'dashboard/components-next/select/Select.vue';

const props = defineProps({
  field: {
    type: Object,
    required: true,
  },
  modelValue: {
    type: [String, Number],
    default: '',
  },
  // Inline error message for this field (built from the structured 422 name).
  error: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

// Native <input type> per field type; `list` renders a Select instead.
const INPUT_TYPES = { text: 'text', number: 'number', date: 'date' };

const options = computed(() =>
  (props.field.options || []).map(option => ({ value: option, label: option }))
);

const onUpdate = value => emit('update:modelValue', value);
</script>

<template>
  <div class="flex flex-col gap-1">
    <label class="text-sm font-medium text-n-slate-12">
      {{ field.name }}
      <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
      <span v-if="field.required" class="text-n-ruby-9">*</span>
    </label>

    <template v-if="field.field_type === 'list'">
      <Select
        :model-value="modelValue || ''"
        class="w-full"
        :options="options"
        :placeholder="t('FUNNELS.CARD.EDIT.SELECT_PLACEHOLDER')"
        @update:model-value="onUpdate"
      />
      <p v-if="error" class="text-xs text-n-ruby-9">{{ error }}</p>
    </template>

    <Input
      v-else
      :model-value="modelValue ?? ''"
      :type="INPUT_TYPES[field.field_type]"
      :message="error"
      :message-type="error ? 'error' : 'info'"
      @update:model-value="onUpdate"
    />
  </div>
</template>
